@if (imageClassStyle.length > 0) {
  <div class="image-grid">
    @for (image of imageURLs; track image; let i = $index) {
      <div class="image-item" [ngClass]="imageClassStyle">
        @if (image.type.includes('image') && image.coverImageURL.length == 0) {
          <img src="{{image.url}}" class="image-preview"
               (click)="showImageDetailsPopup(image.url)" 
               alt="Image preview" />
        }
        @if (image.type.includes('video')) {
          <i class="mdi--file-video-outline" (click)="showImageDetailsPopup(image.url)"></i>
        }
        <a href="{{image.url}}" class="file-icon">
          @if (image.coverImageURL.length > 0) {
            <img src="{{image.coverImageURL}}" [ngClass]="{'fix-height': !smallSplash, 'fix-height-small': smallSplash}">
          }
          @if (image.type.includes('pdf') && image.coverImageURL.length == 0) {
            <span class="fa6-regular--file-pdf"></span>
          }
          @if ((!image.type.includes('application') && !image.type.includes('image') && !image.type.includes('audio') && !image.type.includes('csv') && !image.type.includes('video')) || (image.type.includes('text') && !image.type.includes('csv'))) {
            <span class="mdi--file-text-outline"></span>
          }
          @if ((image.type.includes('word'))) {
            <span class="mdi--file-word-outline"></span>
          }
          @if ((image.type.includes('excel'))) {
            <span class="mdi--file-excel-outline"></span>
          }
          @if ((image.type.includes('powerpoint'))) {
            <span class="mdi--file-powerpoint-outline"></span>
          }
          @if (image.type.includes('audio')) {
            <i class="mdi--file-music-outline"></i>
          }
          @if (image.type.includes('csv')) {
            <i class="mdi--file-csv-outline"></i>
          }
        </a>

        <div class="image-actions">
          @if (canDelete) {
            <button type="button" class="action-btn" (click)="removeImage(image)">
              <span class="mdi--trash"></span>
            </button>
          }
          @if (canUseAI) {
          @if (image.type.includes('audio') && !isPreparingAduioTranscription) {
            <button type="button" class="action-btn" (click)="getAudioTranscription(image.url, image.type)">
              <span class="mdi--music-small"></span>
            </button>
          }
          @if (image.isChecked == true && showSelectionTickers == true) {
            <button type="button" class="action-btn" (click)="checkImage(i)">
              <i class="bi bi-check-circle"></i>
            </button>
          }
          @if (image.isChecked == false && showSelectionTickers == true) {
            <button type="button" class="action-btn" (click)="checkImage(i)">
              <i class="bi bi-circle"></i>
            </button>
          }
          @if (image.type.includes('csv') && image.isAnalyzed == false) {
            @if (site != 'productly') {
              <button type="button" class="action-btn" (click)="convertCSVToTableField(image.url)">
                <span class="material-symbols-light--table-outline"></span>
              </button>
            }
            <button type="button" class="action-btn" (click)="analyzeCVSData(image.url)">
              <img src="../../assets/robot.svg">
            </button>
          }
          @if (image.type.includes('image') && image.isAnalyzed == false) {
            <button type="button" class="action-btn" (click)="extractImageText(image.url)">
              <img src="../../assets/robot.svg">
            </button>
          }
          @if (image.type.includes('video') && !isPreparingAduioTranscription) {
            <button type="button" class="action-btn" (click)="extractAudioFromVideo(image.url, image.type)">
              <span class="mdi--music-small"></span>
            </button>
          }
        }
        </div>
      </div>
    }
  </div>
}